import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {PUT_ENABLE_MEDICAL_CONDITIONS_URL} from '../../constants/apiUrls';
import {GenericErrorResponse, UuidModel} from '../typings';

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutEnableMedicalCondition = ({onSuccess, onError}: Input = {}) => {
  const putEnableMedicalCondition = async (reqBody: UuidModel[]) => {
    await axiosClient.put(PUT_ENABLE_MEDICAL_CONDITIONS_URL, reqBody);
  };

  return useCustomMutation(putEnableMedicalCondition, {
    onSuccess,
    onError,
  });
};
